import { skipToken, useQuery } from "@tanstack/react-query";
import { getPayPointsPublicIDCredential } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const PAYPOINT_CREDENTIAL_QUERY_KEY = "PAYPOINT_CREDENTIAL";

export const payPointCredentialKeys = {
  all: [PAYPOINT_CREDENTIAL_QUERY_KEY],
  byPayPointPublicId: (payPointPublicID?: string | null) => [
    PAYPOINT_CREDENTIAL_QUERY_KEY,
    payPointPublicID,
  ],
};

/**
 * Reads the credential metadata of a single PayPoint (terminal device or e-commerce gateway).
 * `publicID` is the gateway clientId / device public id; the secret is never returned here.
 */
export const usePayPointCredentialQuery = (
  payPointPublicID?: string | null,
  enabled = true,
) =>
  useQuery({
    queryKey: payPointCredentialKeys.byPayPointPublicId(payPointPublicID),
    queryFn:
      enabled && payPointPublicID
        ? processResponseWithApiProblemDetails(() =>
            getPayPointsPublicIDCredential(payPointPublicID),
          )
        : skipToken,
  });
